module.exports = __webpack_public_path__ + "img/flower-huang.08b52029.jpg";